import { render, staticRenderFns } from "./Supplies.vue?vue&type=template&id=90781104&scoped=true"
import script from "./Supplies.vue?vue&type=script&lang=js"
export * from "./Supplies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90781104",
  null
  
)

export default component.exports